import React, { Component } from 'react'
import Select from 'react-select';
import { Button, Divider, Modal } from 'semantic-ui-react'
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import * as moment from 'moment';
import { getOrderKey } from '../../../../config/constants';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });



export default class ReplacementOrder extends Component {
    constructor(props) {
        super(props);

        this.state = ({
            modalOpen: false,
            sentOrderNum:this.props.order.order_num,
            replacementReason:'',
            replaceReasonOptions:[
                { value: 'design_error', label: 'Error with the design' },
                // { value: 'puff', label: 'Wanted puff / Didnt want puff' },
                { value: 'wrong_size', label: 'Wrong size / Didnt Fit' },
                { value: 'wrong_color', label: 'Shirt Wrong color' },
                { value: 'printing_error', label: 'Printing error' },
                { value: 'ltrs_came_off', label: 'Letters, numbers fell off' },
            ],
        })
    }


    openModal = () => {
        this.setState({ modalOpen: true });
    }

    closeModal = () => {
        this.setState({ modalOpen: false });
    }

    getNewOrderNumber = () => {
        console.log("replx10 +++++++:getNewOrderNumber");
        this.closeModal();
        //GET NEW ORDER NUMBER
        FbUtils.getOrderNumberAndUpdateCounter(this.createNewOrderObjectAndSave);
    }

    testUpdateOrder = () => {
        console.log("upx1 +++++++:testUpdateOrder");
        let orderUpdate = {
            replacementOrderMade: true,
            replacementOrderMadeTime: 'now'
        }

       FbUtils.updateOrder(getOrderKey(this.props.order), orderUpdate);
    }

    createNewOrderObjectAndSave = (orderNum) => {
        console.log("replx1 +++++++:createNewOrderObjectAndSave");
        console.log("replx12 got new generated  orderNum:" + orderNum);
        console.log("replx13 old order Number:" + this.props.order.order_num);

        let originalOrderNumber = this.props.order.order_num;
        console.log("replx131 originalOrderNumber:" + originalOrderNumber);

        let now = moment().format('MMMM Do YYYY, h:mm:ss a');

        //CREATE NEW ORDER FROM OLD ORDER
        let tempOrder = this.props.order;
        //console.log("replx14 tempOrder:" + tempOrder.order_num);

        //SET NEW ORDER NUM
        tempOrder.order_num = orderNum;
        tempOrder.replacementOrder = true;
        tempOrder.originalOrder = this.props.orderId;
        console.log("replx14 new tempOrder order number:" + tempOrder.order_num);

        //ADD REPLACMENT ORDER STUFF
        tempOrder.replacement = "yes";
        tempOrder.replacementReason = this.state.replacementReason;

        //tempOrder.replacementOf_order = this.state.sentOrderNum;
        tempOrder.replacementOf_order = originalOrderNumber;
        console.log("replx15 replacementOf_order old order attached to new order:" + tempOrder.replacementOf_order);
        
        tempOrder.replacementOf_order_key = this.props.orderId;
        tempOrder.enteredBy = this.props.user.email;
        tempOrder.lastUdpatedSecs = new Date().getTime();

        //UPDATE NAME
        //tempOrder.name = "**REPL:"+this.state.sentOrderNum+"**  "+tempOrder.name;
        tempOrder.name = "**REPL OF:"+originalOrderNumber+"** "+this.props.order.name;
        console.log("replx16 new order name:"+tempOrder.name )

        tempOrder.replacementBy = this.props.user.email;

        //CHECK IF FROM ARCHIVES
       // if(tempOrder.algoliaArchived){
            console.log("replx161 algoliaArchived true");
            tempOrder.archived = false;
      //  }

        // if(tempOrder.archived){
        //     console.log("replx161 algoliaArchived true");
            tempOrder.algoliaArchived = false;
       // }

        console.log("replx17 final repl order:"+JSON.stringify(tempOrder,null,3))

        //DUPLICATE THE ORDER
        FbUtils.DuplicateOrder(tempOrder);

        //UDPATE OLD ORDER
        let orderUpdate = {
            replacementOrderMade: true,
            replacementOrderMadeTime: now,
            replacementOrderNumber: tempOrder.order_num
        }

       FbUtils.updateOrder(getOrderKey(this.props.order), orderUpdate);

       alert("Replacement Created order num:"+tempOrder.order_num)

        //history.push('/dashboard');

       // history.push('/dashboard/singleOrderView/'+tempOrder.order_num);
    }

    /**
    * HANDLE DROPDOWN FOR ORDER ONE
    */
    replacementReasonChange = (selected) => {
        console.log("++++++++: replacementReasonChange");
        console.log(selected);
        //  console.log("selected json:"+JSON.stringify(selected));
        // console.log('gbv12 You\'ve sss:', value);
        // console.log("plus12:"+value.category);
        // console.log('gbv12 You\'ve selected:', value.value+" "+value.category);

        console.log("Selected: " + selected.value);

        let newState = {};
        newState['replacementReason'] = selected.value;
        console.log("replaceReason:" + JSON.stringify(newState));

        //this.setState(newState);
        this.setState(newState);
    }


    render() {

        const replacementButton = this.state.replacementReason !== ''
            ?<Button onClick={this.openModal} color='brown'>CREATE REPLACEMENT </Button>
            :''

        return (
            <div>
                <Divider horizontal>{'CREATE REPLACEMENT'}</Divider>

                <Modal size={'mini'} open={this.state.modalOpen} onClose={this.close}>
                    <Modal.Header>
                        Replacement Order
                </Modal.Header>
                    <Modal.Content>
                        <p>Are you sure to create a replacement for this order? This will be a separate order</p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button negative onClick={this.closeModal}>
                            No
                        </Button>
                        <Button positive icon='checkmark' labelPosition='right' content='Yes' onClick={this.getNewOrderNumber} />
                    </Modal.Actions>
                </Modal>

                {/* <Button color='red' onClick={this.testUpdateOrder}>TEST IT</Button>  */}

                {/* CANCEL REASON SELECT */}
                <Select
                    value={this.state.replacementReason}
                    options={this.state.replaceReasonOptions}
                    onChange={this.replacementReasonChange}
                    searchable={false}
                    clearable={false}
                />

                {replacementButton}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/ReplacementOrder/ReplacementOrder.js